(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["si-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('si-collection-sort')) {
    customElements.define('si-collection-sort', class extends HTMLElement {
      connectedCallback() {
        this.sortEvents?.abort();
        this.sortEvents = new AbortController();
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-si-sort]')) return;
          event.stopPropagation();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          window.location.assign(url.toString());
        }, { signal: this.sortEvents.signal });
      }

      disconnectedCallback() { this.sortEvents?.abort(); }
    });
  }

  if (!customElements.get('si-collection-filters')) {
    customElements.define('si-collection-filters', class extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
        this.on(this, 'click', this.onCategoryClick.bind(this), { capture: true });
        this.on(document, 'keydown', event => {
          if (event.key === 'Tab') this.setAttribute('data-keyboard-navigation', '');
        });
        this.on(document, 'pointerdown', () => this.removeAttribute('data-keyboard-navigation'));
        this.registerCleanup(theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this)));
      }

      get drawer() { return document.getElementById('FacetDrawerSticky'); }

      async onCategoryClick(event) {
        const button = event.target.closest('[data-si-filter-target]');
        if (!button || !this.contains(button)) return;
        const drawer = this.drawer;
        if (!drawer || typeof drawer.show !== 'function') return;
        event.preventDefault();
        event.stopPropagation();
        const target = Array.from(drawer.querySelectorAll('[data-filter]')).find(group => group.dataset.index === 'sticky-' + button.dataset.siFilterTarget);
        if (!target) return;
        const token = this.navigationToken = {};
        drawer.querySelectorAll('details[data-filter]').forEach(group => { group.open = group === target; });
        const animations = drawer.getAnimations({ subtree: true }).map(animation => animation.finished.catch(() => {}));
        await Promise.all([drawer.show(button), ...animations]);
        if (!this.isConnected || this.navigationToken !== token || !drawer.open) return;
        const control = target.querySelector('summary, input:not([type="hidden"])');
        control?.focus({ preventScroll: true });
        const scroller = drawer.querySelector('.drawer__scrollable');
        if (scroller) scroller.scrollTo({ top: scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 8, behavior: 'auto' });
      }

      onFacetUpdate(event) {
        const html = event.parsedHTML || new DOMParser().parseFromString(event.responseText, 'text/html');
        const incoming = html.querySelector('si-collection-filters');
        if (!incoming || incoming.dataset.sectionId !== this.dataset.sectionId) return;
        const count = this.querySelector('[data-si-filter-count]');
        if (count) count.textContent = incoming.querySelector('[data-si-filter-count]').textContent;
        this.querySelectorAll('[data-si-filter-target]').forEach(button => {
          const source = Array.from(incoming.querySelectorAll('[data-si-filter-target]')).find(other => other.dataset.siFilterTarget === button.dataset.siFilterTarget);
          if (source) button.dataset.active = source.dataset.active;
        });

      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["si-product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('si-pd-video')) {
    customElements.define('si-pd-video', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(max-width: 700px)');
        this.onChange = () => this.selectVideo();
        this.breakpoint.addEventListener('change', this.onChange);
        this.selectVideo();
      }
      disconnectedCallback() {
        this.breakpoint?.removeEventListener('change', this.onChange);
        this.querySelector(':scope > video')?.pause();
      }
      selectVideo() {
        const mobile = this.querySelector('template[data-si-video="mobile"]');
        const selected = this.breakpoint.matches && mobile ? mobile : this.querySelector('template[data-si-video="desktop"]');
        if (!selected || this.selected === selected && this.querySelector(':scope > video')) return;
        const previous = this.querySelector(':scope > video');
        if (previous) { previous.pause(); previous.remove(); }
        this.append(selected.content.cloneNode(true));
        this.selected = selected;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
